import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import RestaurantForm from './RestaurantForm'
import { Restaurant, CreateRestaurantInput, UpdateRestaurantInput } from '@/queries/useRestaurants'
import { useTranslation } from 'react-i18next'

interface RestaurantDialogProps {
  restaurant: Restaurant | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: CreateRestaurantInput | UpdateRestaurantInput) => void | Promise<void>
  isLoading?: boolean
  error?: Error | null
}

export default function RestaurantDialog({
  restaurant,
  open,
  onOpenChange,
  onSubmit,
  isLoading = false,
  error,
}: RestaurantDialogProps) {
  const { t } = useTranslation('admin')
  const isEditMode = !!restaurant

  const handleSubmit = async (data: CreateRestaurantInput | UpdateRestaurantInput) => {
    await onSubmit(data)
    onOpenChange(false)
  }

  const handleCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[500px]"
        data-testid={isEditMode ? 'edit-restaurant-dialog' : 'create-restaurant-dialog'}
      >
        <DialogHeader>
          <DialogTitle data-testid="restaurant-dialog-title">
            {isEditMode ? t('restaurants.dialog.editTitle') : t('restaurants.dialog.createTitle')}
          </DialogTitle>
          <DialogDescription data-testid="restaurant-dialog-description">
            {isEditMode
              ? t('restaurants.dialog.editDescription')
              : t('restaurants.dialog.createDescription')}
          </DialogDescription>
        </DialogHeader>

        <RestaurantForm
          restaurant={restaurant}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  )
}

